module.exports = __webpack_public_path__ + "img/verbal-report-red.ed8503c8.svg";